import { Button } from "@/components/ui/button";
import { ChecklistItem } from "@/features/onboarding/components/wizard";
import { LanguagePicker, useT } from "@/features/onboarding/i18n";

export function WelcomeStep({
  hasReferral,
  agentName,
  onStart,
}: {
  hasReferral: boolean;
  agentName?: string | null;
  onStart: () => void;
}) {
  const t = useT();
  return (
    <div className="text-center py-4">
      <div className="mx-auto mb-5 w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="1.75" className="text-primary" strokeLinecap="round" strokeLinejoin="round"
          aria-hidden="true">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-slate-900">{t("welcome.title")}</h1>
      <div className="mx-auto mt-4 w-fit max-w-full rounded-xl bg-primary/10 px-4 pb-4 pt-1">
        <LanguagePicker />
      </div>
      <p className="mt-2 text-sm text-slate-600 max-w-md mx-auto">
        {t("welcome.intro")}
      </p>
      {hasReferral && (
        <p className="mt-1 text-sm text-slate-500">
          {t("page.referredBy")}{" "}
          <span className="font-medium text-slate-700">{agentName ?? t("page.aBlogicAgent")}</span>
        </p>
      )}

      <div className="mt-7 flex justify-center">
        <div className="text-left">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 text-center">
            {t("welcome.need")}
          </div>
          <ul className="space-y-3">
            <ChecklistItem icon="building">{t("welcome.need1")}</ChecklistItem>
            <ChecklistItem icon="user">{t("welcome.need2")}</ChecklistItem>
            <ChecklistItem icon="card">{t("welcome.need3")}</ChecklistItem>
            <ChecklistItem icon="check">{t("welcome.need4")}</ChecklistItem>
          </ul>
        </div>
      </div>

      <Button type="button" size="lg" onClick={onStart} className="mt-7 w-full max-w-xs mx-auto gap-2">
        {t("welcome.start")}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>
      </Button>

    </div>
  );
}
